import type { QueryClient } from '@tanstack/react-query';
import {
  userPreferencesQueryKey,
  type UserPreferences,
  type UserPreferencesUpdates,
} from './user';

export const buildUserPreferencesLifecycle = (client: QueryClient) => ({
  onSuccess: (_: unknown, updates: UserPreferencesUpdates) => {
    client.setQueryData(
      userPreferencesQueryKey,
      (old: UserPreferences | undefined) =>
        old ? { ...old, ...updates } : undefined,
    );
    return client.invalidateQueries({ queryKey: userPreferencesQueryKey });
  },
});
